export default __webpack_public_path__ + "static/media/786.58e94b77.jpg";